export function shiftStateCount(state: string, by: number): void {
  const count = document.querySelector(`.inbox-tab[data-response-state="${state}"] .inbox-count`)
  if (!count) return

  count.textContent = String(Math.max(0, (parseInt(count.textContent || "0", 10) || 0) + by))
}

export function refreshSubtitle(): void {
  const subtitle = document.querySelector(".inbox-page-subtitle")
  const active = document.querySelector(".inbox-tab.active .inbox-count")
  if (!subtitle || !active) return

  subtitle.textContent = `${(active.textContent || "0").trim()} replies awaiting your response`
}

export function shiftManagedScopeCount(by: number): void {
  const button = document.querySelector(".inbox-scope-seg [data-scope='managed']")
  if (!button) return

  const match = (button.textContent || "").match(/^(.*·\s*)(\d+)\s*$/)
  if (match) button.textContent = `${match[1]}${Math.max(0, parseInt(match[2], 10) + by)}`
}

// "Showing 1–3 of 3" → "Showing 1–2 of 2"; the next page's rows only slide in on the next load.
export function lowerPagerSummary(list: Element, by = 1): void {
  const range = list.querySelector(".inbox-pager-summary b")
  const total = range?.nextSibling
  if (!range || !total) return

  const [first, last] = (range.textContent || "").split("–").map(n => parseInt(n, 10))
  const of = parseInt((total.textContent || "").replace(/\D/g, ""), 10)
  if ([first, last, of].some(n => isNaN(n))) return

  range.textContent = `${first}–${Math.max(first, last - by)}`
  total.textContent = ` of ${Math.max(0, of - by)}`
}

// Untick first: the bulk bar recounts on change, and must not count a row that is gone.
export function detachRow(row: HTMLElement): void {
  const select = row.querySelector<HTMLInputElement>(".inbox-row-select input:checked")
  if (select) {
    select.checked = false
    select.dispatchEvent(new Event("change", { bubbles: true }))
  }

  row.remove()
}
